// Knives in the hand are lit without specular highlights: the white sun glare washed out their
// skins (the same fix as the level textures, see mapMaterial.ts). Every knife that goes into the hand
// passes through this, so knives added later get it too.

import * as THREE from 'three';

/** Take the highlights off every material under `root` (materials are shared, so once is enough). */
export function noHighlights(root: THREE.Object3D) {
  root.traverse((o) => {
    if (!(o instanceof THREE.Mesh)) return;
    for (const m of Array.isArray(o.material) ? o.material : [o.material]) {
      if (m instanceof THREE.MeshPhongMaterial) {
        m.specular.setRGB(0, 0, 0);
        m.specularMap = null;
        m.shininess = 0;
      } else if (m instanceof THREE.MeshStandardMaterial) {
        m.roughness = 1;
        m.metalness = 0;
        m.envMap = null;
      } else continue;
      m.needsUpdate = true;
    }
  });
}
